// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomPane_root__sUbiu","item":"CustomPane_item__ZUpnq","itemNotLast":"CustomPane_itemNotLast__bC_Vu","itemLast":"CustomPane_itemLast__PO6J9"};